
<p-chip class="mb-3 text-xs flex justify-between" [class.w-fit]="!columnView" [class.w-full]="columnView"
  [class.bg-green-200]="['Player','Player (Under 16)'].includes(primaryTicket?.name ?? '')"
  >
  <div class="flex gap-2">
    <div class="flex flex-col justify-center">
      @if (primaryTicket?.name?.includes('Player')){
        <fa-icon [icon]="['fas','ticket']" />
      }
      @else if (primaryTicket?.name?.includes('Crew')){
      <fa-icon [icon]="['fas','spaghetti-monster-flying']" />
    }
    @else {
    <fa-icon [icon]="['fas','stopwatch']" />
  }

</div>
<p class="mt-1">{{ primaryTicket?.description }}</p>
</div>
@if (includePrice) {
  <div>{{ primaryTicket?.cost | currency:'GBP'}}</div>
}
</p-chip>
@if (additionalTickets){
  @for (ticket of additionalTickets; track ticket.ticketID){
    <p-chip class="mb-3 text-xs flex justify-between" [class.w-fit]="!columnView" [class.w-full]="columnView">
      <div class="flex gap-2">
        <div class="flex flex-col justify-center">
          @if (ticket.name.includes('bunk')){
            <fa-icon [icon]="['fas','bed']" />
          }
          @if (ticket.name.includes('meal')){
            <fa-icon [icon]="['fas','utensils']" />
          }
        </div>
        <p class="mt-1">{{ ticket.description }}</p>
      </div>
      @if (includePrice) {
        <div>{{ ticket.cost | currency:'GBP'}}</div>
      }
    </p-chip>
  }
}
